import OptionList from '@/components/option/OptionList'
import OptionCreate from '@/components/option/OptionCreate'
import ResaCreate from '@/components/option/ResaCreate'

export default [
  {
    path: '/options',
    name: 'OptionList',
    component: OptionList,
    meta: {
      parentName: 'Home',
      requiresAuth: true
    }
  },
  {
    path: '/options/creation',
    name: 'OptionCreate',
    component: OptionCreate,
    meta: {
      parentName: 'OptionList',
      requiresAuth: true,
      maxHeight: true
    }
  },
  {
    path: '/options/:id/reservation',
    name: 'ResaCreate',
    component: ResaCreate,
    meta: {
      requiresAuth: true,
      maxHeight: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/optionRouter.js